import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";

export default function CreateCampaign() {
  const [campaignType, setCampaignType] = useState("single");
  const [scheduleType, setScheduleType] = useState("once");
  const [contacts, setContacts] = useState([]);

  const [templates, setTemplates] = useState([]);

  const [variables, setVariables] = useState([]);

  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [campaignName, setCampaignName] = useState("");

  const [phone, setPhone] = useState("");

  const [date, setDate] = useState("");

  const [time, setTime] = useState("");

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const response = await axios.get(
        "https://tanwacapi.synoweberp.in/api/template/all",
      );

      setTemplates(response.data.templates.templates || []);
    } catch (error) {
      console.log(error);
    }
  };

  const variableCount = selectedTemplate?.placeholder?.bodyvar || 0;

  const previewMessage = useMemo(() => {
    if (!selectedTemplate) return "";

    let text = JSON.parse(selectedTemplate.jsonstruct)?.body?.text || "";

    variables.forEach((value, index) => {
      const regex = new RegExp(`{{${index + 1}}}`, "g");

      text = text.replace(regex, value || `{{${index + 1}}}`);
    });

    return text;
  }, [selectedTemplate, variables]);

  const handleExcelUpload = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);

      const workbook = XLSX.read(data, {
        type: "array",
      });

      const sheetName = workbook.SheetNames[0];

      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      const formattedContacts = jsonData.map((item) => {
        const dynamicVariables = [];

        Object.keys(item).forEach((key) => {
          if (key.startsWith("var")) {
            const index = Number(key.replace("var", ""));

            dynamicVariables[index - 1] = item[key];
          }
        });

        return {
          phone: item.phone,
          variables: dynamicVariables,
        };
      });

      setContacts(formattedContacts);
    };

    reader.readAsArrayBuffer(file);
  };

  const downloadSampleExcel = () => {
    if (!selectedTemplate) {
      alert("Please select template first");

      return;
    }

    const sampleRow1 = {
      phone: "+9198965xxxx8",
    };

    const sampleRow2 = {
      phone: "+919999999999",
    };

    for (let i = 1; i <= variableCount; i++) {
      sampleRow1[`var${i}`] = `Sample ${i}`;

      sampleRow2[`var${i}`] = `Demo ${i}`;
    }

    const sampleData = [sampleRow1, sampleRow2];

    const worksheet = XLSX.utils.json_to_sheet(sampleData);

    worksheet["!cols"] = [
      { wch: 20 },

      ...Array(variableCount).fill({
        wch: 25,
      }),
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample Data");

    XLSX.writeFile(workbook, "whatsapp_campaign_sample.xlsx");
  };

  const resetForm = () => {
    setPhone("");

    setVariables([]);

    setContacts([]);

    setDate("");

    setTime("");

    setScheduleType("once");
  };

  const handleCreateCampaign = async () => {
    try {
      if (!selectedTemplate) {
        alert("Please select template");

        return;
      }

      const scheduleTime = new Date(`${date}T${time}`);

      const now = new Date();

      if (scheduleTime <= now) {
        alert("Please select future date & time");

        return;
      }
      const payload = {
        scheduleType,
        campaignName,
        campaignType,
        templateId: selectedTemplate.id,

        scheduleTime: scheduleTime.toISOString(),

        contacts:
          campaignType === "single"
            ? [
                {
                  phone,
                  variables,
                },
              ]
            : contacts,
      };

      const response = await axios.post(
        "https://tanwacapi.synoweberp.in/api/campaign/create",
        payload,
      );

      alert(response.data.message);
      setSelectedTemplate(null);

      setCampaignName("");

      setCampaignType("single");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div className="text-center w-full">
          <h1 className="text-4xl font-bold">Create Campaign</h1>

          <p className="text-gray-500 mt-2">
            Create and schedule WhatsApp campaigns
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded-2xl shadow-sm p-5">
  <div className="space-y-5">
    {/* Template */}
    <div>
      <label className="block mb-2 font-medium">
        Select Campaign Template
      </label>

      <select
        value={campaignName}
        onChange={(e) => {
          setCampaignName(e.target.value);

          const selected = templates.find(
            (item) => item.name === e.target.value,
          );

          setSelectedTemplate(selected);

          resetForm();
        }}
        className="w-full border border-gray-300 rounded-2xl px-4 py-3 bg-white"
      >
        <option value="">
          Select Template Campaign
        </option>

        {templates.map((template, index) => (
          <option
            key={index}
            value={template.name}
          >
            {template.name}
          </option>
        ))}
      </select>
    </div>

    {/* Campaign + Schedule */}
    <div className="grid grid-cols-2 gap-4">
      {/* Campaign Type */}
      <div>
        <label className="block mb-2 font-medium">
          Campaign Type
        </label>

        <div className="flex gap-3">
          <button
            onClick={() => {
              setCampaignType("single");
              resetForm();
            }}
            className={`flex-1 px-5 py-3 rounded-2xl ${
              campaignType === "single"
                ? "bg-black text-white"
                : "bg-gray-200"
            }`}
          >
            Single
          </button>

          <button
            onClick={() => {
              setCampaignType("bulk");
              resetForm();
            }}
            className={`flex-1 px-5 py-3 rounded-2xl ${
              campaignType === "bulk"
                ? "bg-black text-white"
                : "bg-gray-200"
            }`}
          >
            Bulk
          </button>
        </div>
      </div>

      {/* Schedule Type */}
      <div>
        <label className="block mb-2 font-medium">
          Schedule Type
        </label>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={() =>
              setScheduleType("once")
            }
            className={`flex-1 px-5 py-3 rounded-2xl ${
              scheduleType === "once"
                ? "bg-black text-white"
                : "bg-gray-200"
            }`}
          >
            Once
          </button>

          <button
            type="button"
            onClick={() =>
              setScheduleType("daily")
            }
            className={`flex-1 px-5 py-3 rounded-2xl ${
              scheduleType === "daily"
                ? "bg-black text-white"
                : "bg-gray-200"
            }`}
          >
            Daily
          </button>
        </div>
      </div>
    </div>

    {/* Single User */}
    {campaignType === "single" && (
      <div className="grid grid-cols-2 gap-4 items-start">
        {/* Phone */}
        <div>
          <label className="block mb-2 font-medium">
            Phone Number
          </label>

          <input
            type="text"
            value={phone}
            onChange={(e) =>
              setPhone(e.target.value)
            }
            placeholder="Enter Phone Number"
            className="w-full border border-gray-300 rounded-2xl px-4 py-3"
          />
        </div>

        {/* Variables */}
        {variableCount > 0 && (
          <div>
            <label className="block mb-2 font-medium">
              Dynamic Variables
            </label>

            <div className="grid grid-cols-2 gap-3">
              {Array.from({
                length: variableCount,
              }).map((_, index) => (
                <input
                  key={index}
                  type="text"
                  value={
                    variables[index] || ""
                  }
                  onChange={(e) => {
                    const updated = [
                      ...variables,
                    ];

                    updated[index] =
                      e.target.value;

                    setVariables(updated);
                  }}
                  placeholder={`var${
                    index + 1
                  }`}
                  className="w-full border border-gray-300 rounded-2xl px-4 py-3"
                />
              ))}
            </div>
          </div>
        )}
      </div>
    )}

    {/* Bulk */}
    {campaignType === "bulk" && (
      <div>
        <label className="block mb-2 font-medium">
          Upload Excel
        </label>

        <div className="space-y-3">
          <label className="border-2 border-dashed border-gray-300 rounded-2xl p-5 text-center bg-gray-50 cursor-pointer block hover:bg-gray-100 transition-all">
            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={
                handleExcelUpload
              }
              className="hidden"
            />

            <p className="font-semibold">
              Upload Excel File
            </p>

            <p className="text-sm text-gray-500 mt-1">
              Select .xlsx or .xls file
            </p>
          </label>

          <button
            onClick={
              downloadSampleExcel
            }
            className="bg-black text-white px-5 py-3 rounded-2xl"
          >
            Download Sample
          </button>

          {contacts.length > 0 && (
            <div className="bg-green-50 border border-green-200 rounded-2xl p-3">
              <p className="text-green-700 font-medium">
                {contacts.length} Contacts
                Loaded
              </p>
            </div>
          )}
        </div>
      </div>
    )}

    {/* Date + Time */}
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block mb-2 font-medium">
          Date
        </label>

        <input
          type="date"
          value={date}
          onChange={(e) =>
            setDate(e.target.value)
          }
          className="w-full border border-gray-300 rounded-2xl px-4 py-3"
        />
      </div>

      <div>
        <label className="block mb-2 font-medium">
          Time
        </label>

        <input
          type="time"
          value={time}
          onChange={(e) =>
            setTime(e.target.value)
          }
          className="w-full border border-gray-300 rounded-2xl px-4 py-3"
        />
      </div>
    </div>

    {/* Submit */}
    <button
      onClick={handleCreateCampaign}
      className="w-full bg-black text-white py-3 rounded-2xl font-medium"
    >
      Schedule Campaign
    </button>
  </div>
</div>

        <div className="bg-white rounded-3xl shadow-sm p-6 h-fit sticky top-5">
          <h2 className="text-2xl font-bold mb-5">Preview</h2>

          {selectedTemplate ? (
            <div className="space-y-5">
              <div className="bg-[#DCF8C6] rounded-3xl p-5 shadow-sm">
                <p className="whitespace-pre-line text-gray-800 leading-7">
                  {previewMessage.split(/(\{\{\d+\}\})/g).map((part, index) => {
                    const match = part.match(/\{\{(\d+)\}\}/);

                    if (match) {
                      const variableIndex = Number(match[1]) - 1;

                      return (
                        <span
                          key={index}
                          className="bg-yellow-200 px-1 rounded"
                        >
                          {variables[variableIndex] ||
                            `{{${variableIndex + 1}}}`}
                        </span>
                      );
                    }

                    return <span key={index}>{part}</span>;
                  })}
                </p>
              </div>

              <div className="bg-gray-50 rounded-2xl p-4 border border-gray-200">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-semibold">Template Details</h3>

                  <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">
                    {selectedTemplate.status}
                  </span>
                </div>

                <div className="space-y-2 text-sm">
                  <p>
                    <span className="font-medium">Category:</span>{" "}
                    {selectedTemplate.category}
                  </p>

                  <p>
                    <span className="font-medium">Language:</span>{" "}
                    {selectedTemplate.lang}
                  </p>

                  <p>
                    <span className="font-medium">Quality:</span>{" "}
                    {selectedTemplate.quality}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-gray-50 rounded-2xl p-10 text-center border border-dashed border-gray-300">
              <p className="text-gray-500">
                Select a template to preview message
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
